import React, { useState } from "react";
import classes from "./Search.module.css";
import { Link, useNavigate } from "react-router-dom";

import { AllProducts } from "../../components/Shop/ShopController";

function Search() {
  const [filteredData, setFilteredData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const navigate = useNavigate();

  const showProductDetailsHandler = () => {
    setFilteredData([]);
    // setSearchValue("");
  };

  const handleChangeFilter = (event) => {
    const value = event.target.value;
    setSearchValue(event.target.value);
    const newFilter = AllProducts.filter((item) => {
      return item.title.toLowerCase().includes(value.toLowerCase());
    });

    if (value === "") setFilteredData([]);
    else setFilteredData(newFilter);
  };

  const searchBtnHandler = () => {
    navigate({
      pathname: "/shop",
      search: `?query=${searchValue}`,
    });
    setFilteredData([]);
  };

  const enterButtonHandler = (event) => {
    if (event.key === "Enter") {
      searchBtnHandler();
    }
  };

  return (
    <div className={classes.search}>
      <div className={classes["search-input"]}>
        <input
          value={searchValue}
          onKeyDown={enterButtonHandler}
          onChange={handleChangeFilter}
          className={classes.input}
          type="search"
          placeholder="Search For Product..."
          id="header-search"
        />
        {filteredData.length !== 0 && (
          <div className={classes["search-result"]}>
            <ul>
              {filteredData.map((item) => {
                return (
                  <li key={item.id}>
                    <div>
                      <Link
                        onClick={showProductDetailsHandler}
                        to={`/${item.id}`}
                      >
                        <img src={item.images[0]} alt="" />
                      </Link>
                      <Link
                        className={classes.title}
                        onClick={showProductDetailsHandler}
                        to={`/${item.id}`}
                      >
                        {item.title}
                      </Link>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </div>
      <div>
        <button onClick={searchBtnHandler} className={classes.button}>
            <svg xmlns="http://www.w3.org/2000/svg"  width="20" height="20" viewBox="0 0 48 48" id="search"><path fill="white" d="M46.599 40.236L36.054 29.691C37.89 26.718 39 23.25 39 19.5 39 8.73 30.27 0 19.5 0S0 8.73 0 19.5 8.73 39 19.5 39c3.75 0 7.218-1.11 10.188-2.943l10.548 10.545a4.501 4.501 0 0 0 6.363-6.366zM19.5 33C12.045 33 6 26.955 6 19.5S12.045 6 19.5 6 33 12.045 33 19.5 26.955 33 19.5 33z"></path></svg>
        </button>
      </div>
    </div>
  );
}

export default Search;
